export default {
  id: 'e9d114124c',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page ios-home" data-name="home">\n    <!-- Scrollable page content-->\n    <div class="page-content ios-home__content">\n      <div class="flex center top-circle text-color-white ios-home__hero">\n          <div class="text-align-center ios-home__hero-icon">\n            <img src="images/success.png" alt="Success" class="icon ios-home__icon" height="100">\n          </div>\n          <h2 class="text-color-white ios-home__title">Congratulations!</h2>\n          <p class="ios-home__subtitle">You can get a loan of upto <span class="f-18 maxLoan ios-home__max-loan"></span></p>\n          <div class="dark-background ios-home__glow"></div>\n      </div>\n      <div class="flex center bottom-info ios-home__bottom">\n        <div class="list no-hairlines">\n          <ul>\n              <li>\n                <a href="/form2/" class="button button-large button-fill text-color-white text-align-center margin-bottom button-gradient button-shine ios-home__cta">Finish KYC</a>\n              </li>\n          </ul>\n        </div>\n        <div class="text-color-gray display-flex flex-direction-row block f-12 ios-home__note">\n          <img src="images/shield.png" alt="Security" height="24" class="ios-home__note-icon">\n          <span class="ios-home__note-text">Please complete your KYC to get the best offers for you, your information is 100% safe & secure with latest encryption technology.</span>\n        </div>\n      </div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  style: `
  /* iOS-styled Home (Primary: #F24A1C, BG: #1d1d1d) */
  .ios-home,
  .ios-home .page-content {
    background: #1d1d1d;
    color: #ffffff;
  }

  .ios-home__content {
    padding-top: calc(var(--f7-safe-area-top) + 16px);
    padding-bottom: calc(var(--f7-safe-area-bottom) + 20px);
  }

  .ios-home__hero {
    position: relative;
    top: -20px;
    padding: 84px 20px 30px;
    overflow: hidden;
    border-bottom-left-radius: 28px;
    border-bottom-right-radius: 28px;
    background:
      radial-gradient(80% 60% at 50% 0%, rgba(242, 74, 28, 0.38) 0%, rgba(29, 29, 29, 0) 70%),
      linear-gradient(180deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.00) 65%);
  }

  .ios-home__glow {
    position: absolute;
    inset: -40% -30% auto;
    height: 240px;
    background: radial-gradient(circle at 50% 50%, rgba(242, 74, 28, 0.35) 0%, rgba(242, 74, 28, 0) 70%);
    filter: blur(10px);
    pointer-events: none;
  }

  .ios-home__hero-icon {
    margin-top: 25px;
    margin-bottom: 10px;
  }

  .ios-home__icon {
    border-radius: 24px;
    filter: drop-shadow(0 14px 28px rgba(0, 0, 0, 0.45));
  }

  .ios-home__title {
    margin: 6px 0 6px;
    font-size: 26px;
    font-weight: 800;
    letter-spacing: -0.02em;
  }

  .ios-home__subtitle {
    margin: 0;
    font-size: 15px;
    opacity: 0.92;
  }

  .ios-home__max-loan {
    color: #F24A1C;
    font-weight: 800;
  }

  .ios-home__bottom {
    padding: 18px 20px 0;
  }

  .ios-home__cta {
    width: min(320px, 92vw);
    height: 54px;
    line-height: 54px;
    padding: 0 18px;
    border-radius: 16px;
    background: linear-gradient(135deg, #F24A1C 0%, #FF6A3B 100%);
    box-shadow:
      0 14px 30px rgba(242, 74, 28, 0.30),
      0 8px 16px rgba(0, 0, 0, 0.35);
    border: 1px solid rgba(255, 255, 255, 0.10);
  }

  /* Make existing shine effect feel more iOS-like */
  .ios-home__cta.button-shine {
    position: relative;
    overflow: hidden;
  }

  .ios-home__cta.button-shine::after {
    content: '';
    position: absolute;
    top: -20%;
    left: -40%;
    width: 40%;
    height: 140%;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.18) 50%, rgba(255, 255, 255, 0) 100%);
    transform: skewX(-18deg);
    animation: ios-home-shine 2.6s ease-in-out infinite;
  }

  @keyframes ios-home-shine {
    0% { transform: translateX(-140%) skewX(-18deg); opacity: 0; }
    25% { opacity: 1; }
    55% { opacity: 0.85; }
    100% { transform: translateX(420%) skewX(-18deg); opacity: 0; }
  }

  .ios-home__note {
    margin-top: 18px;
    gap: 10px;
    padding: 12px 12px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }

  .ios-home__note-icon {
    filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.35));
    opacity: 0.95;
  }

  .ios-home__note-text {
    line-height: 1.35;
    opacity: 0.92;
  }
`,
  styleScoped: false
};